import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect, withRouter } from 'react-router-dom';
import Header from 'components/Guest/PreJoin/Header';
import PreJoinLayout from 'components/Guest/PreJoin/PreJoinLayout';
import CookieBanner from 'components/Guest/CookieBanner';
import { SplashLayout } from './SplashLayout';
import { isIosMobile } from 'utils/browser-utils';
import InCallContainer from 'containers/InCall/InCall/InCallContainer';
import { constants as c, hooks } from '@lifesize/clients.sdk';
import usePrevious from 'hooks/usePrevious';
import { callReasons } from 'constants/Guest';
import { navigateToTrialPage } from 'utils/guest-utils';
import CallStatus from './CallStatus';
import ButtonBarRetry from './ButtonBarRetry';

export interface GuestContainerProps {}

const GuestLandingPage = () => {
  const isGuestFlowEnabled = useSelector((state: any) => state?.app?.guestFlow?.isEnabled);
  const call = hooks.useCallState();
  const callState = call.state;
  const callReason = call.reason;
  // const callConnected = callState && callState === c.CALL_STATE_CONNECTED;
  const previousCallState = usePrevious(call.state, '');

  // navigate to trial page after successful call and the other end hangs up
  useEffect(() => {
    if (
      previousCallState === c.CALL_STATE_CONNECTED &&
      callState === c.CALL_STATE_DISCONNECTED &&
      callReasons.successful.includes(callReason)
    ) {
      navigateToTrialPage();
    }
  }, [call, callState, previousCallState, callReason]);

  if (!isGuestFlowEnabled) {
    return <Redirect push to={'/'} />;
  }

  if (isIosMobile() && !window.location.href.includes('bypassSplash=true')) {
    return <SplashLayout />;
  }

  return (
    <>
      {callReason === 'rejected' ? (
        <>
          <CallStatus />
          <ButtonBarRetry />
        </>
      ) : (
        <>
          <Header />
          <PreJoinLayout />
          <CookieBanner />
          <InCallContainer />
        </>
      )}
    </>
  );
};

export default withRouter(GuestLandingPage);
